module.exports = __webpack_public_path__ + "img/home-delivery-date-top-img_small.3a6fa64b.jpg";